const DEFAULT_DATA = {
  ready: [],
  reserved: [],
};

export default DEFAULT_DATA;
